import {
  DEFAULT_THEME,
  isThemeSupported,
  resolveTheme,
  THEME_ALIASES,
  ThemeAlias,
} from '@neptune/shared/venus-domain';

function loadTheme(): ThemeAlias {
  const value = localStorage.getItem('neptune-theme') || DEFAULT_THEME;

  return isThemeSupported(value) ? value : DEFAULT_THEME;
}

/**
 * Temporary workaround for hardcoded black color.
 *
 * @note: this is a temporary workaround for the hardcoded black color in the theme.
 * @note: this should be removed after the migration to color tokens on BE side is finished.
 */
export function temporaryWorkaroundForHardcodedBlackColor<T extends string | undefined>(color: T) {
  const theme = resolveTheme(loadTheme());

  if (theme === THEME_ALIASES.DARK) {
    return color === '#000' || color === '#000000' ? '#ffffff' : color;
  }

  return color;
}
